import { Expose } from "class-transformer";
import { IsNumber } from "class-validator";

export abstract class FloorplanNode {
  @IsNumber()
  @Expose({ name: "x" })
  private _x: number;

  @IsNumber()
  @Expose({ name: "y" })
  private _y: number;

  protected constructor(x: number, y: number) {
    this._x = x;
    this._y = y;
  }

  get x(): number {
    return this._x;
  }

  get y(): number {
    return this._y;
  }

  set x(value: number) {
    this._x = value;
  }

  set y(value: number) {
    this._y = value;
  }

  updatePosition(x: number, y: number) {
    this._x = x;
    this._y = y;
  }

  abstract get locked(): boolean;
}
